import { render, staticRenderFns } from "./vrt_transaction.vue?vue&type=template&id=30b71eca&"
import script from "./vrt_transaction.vue?vue&type=script&lang=js&"
export * from "./vrt_transaction.vue?vue&type=script&lang=js&"
import style0 from "./vrt_transaction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports